module.exports = __webpack_public_path__ + "media/slide4/contractMediaSlide4Part1vs-097baf85.png";